import React, { useCallback, useEffect, useReducer, useState } from "react"
import { periodoPadrao7Dias } from "../../../functions/periodoData"
import { obterHistoricoFechamentos } from "../../../services/historicoFechamentos"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { HistoricoFechamentosInicial } from "../models/historicoFechamentosModel"
import { HistoricoFechamentosActionsTypes } from "./historicoFechamentosActions"
import { HistoricoFechamentosContext } from "./HistoricoFechamentosContext"
import { historicoFechamentosReducer } from "./historicoFechamentosReducer"

export function HistoricoFechamentosContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(historicoFechamentosReducer, HistoricoFechamentosInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const periodoInicial = periodoPadrao7Dias()
    const [dataInicio, setDataInicio] = useState(periodoInicial.inicio)
    const [dataFim, setDataFim] = useState(periodoInicial.fim)
    const setLoading = useLoadingStore(s => s.setLoading)

    const recarregar = useCallback(
        async (inicio?: string, fim?: string) => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao) return
            try {
                setLoading(true)
                const response = await obterHistoricoFechamentos(autorizacao, inicio, fim)
                if ("retornoErro" in response) {
                    setErroCarregamento(
                        response.mensagem || "Erro ao carregar histórico de fechamentos"
                    )
                } else {
                    setErroCarregamento(null)
                    dispatch({ type: HistoricoFechamentosActionsTypes.CARREGAR, payload: response })
                }
            } catch {
                setErroCarregamento("Erro ao carregar histórico de fechamentos")
            } finally {
                setLoading(false)
            }
        },
        [setLoading]
    )

    useEffect(() => {
        recarregar(periodoInicial.inicio, periodoInicial.fim)
    }, [])

    return (
        <HistoricoFechamentosContext.Provider
            value={{
                dados,
                dispatch,
                erroCarregamento,
                dataInicio,
                dataFim,
                setDataInicio,
                setDataFim,
                recarregar,
            }}
        >
            <Loading />
            {children}
        </HistoricoFechamentosContext.Provider>
    )
}
